(function () {
  if (window.__seasarOrderLimit) return;
  window.__seasarOrderLimit = true;

  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }
  function olMsg(tpl, n) { return (tpl || 'こちらの商品はおひとり様{N}点までです。').replace('{N}', n); }
  /* append the configured "already in cart / can't add more" suffix to an add-blocked warning (not the static note) */
  function withSuffix(msg, cfg) {
    var sfx = cfg && cfg.suffix;
    if (!sfx || !msg) return msg;
    return msg.replace(/[。.．\s]+$/, '') + '。' + sfx;
  }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function readConfig() {
    var el = document.querySelector('[data-ol-config]');
    return {
      el: el,
      totalMax: el ? num(el.getAttribute('data-ol-total-max')) : 0,
      tpl: (el && el.getAttribute('data-ol-alert-tpl')) || '1回のご注文は合計{N}点までです。数量をご調整ください。',
      prodTpl: (el && el.getAttribute('data-ol-product-alert-tpl')) || 'こちらの商品はおひとり様{N}点までです。',
      blockExpress: el ? el.getAttribute('data-ol-block-express') === 'true' : false,
      suffix: (el && el.getAttribute('data-ol-blocked-suffix')) || ''
    };
  }
  function hasGroupLimits() {
    return !!document.querySelector('[data-ol-max-product],[data-ol-max-variant],[data-ol-card]');
  }
  function enabled(cfg) { return (cfg.totalMax > 0) || hasGroupLimits(); }

  /* ---- cart state (cached; refreshed on cart events) ---- */
  var _cart = null;
  function setCart(c) { if (c && typeof c.item_count === 'number') _cart = c; }
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCart(c); return c; })
      .catch(function () { return _cart; });
  }

  /* ---- group-limit maps from DOM lines (cart drawer / cart page) ---- */
  function groupMaps() {
    var prodMax = {}, varMax = {}, prodScope = {}, prodMsg = {}, varMsg = {};
    var lines = [].slice.call(document.querySelectorAll('[data-ol-product-id]:not([data-ol-card])'));
    lines.forEach(function (el) {
      var pid = el.getAttribute('data-ol-product-id');
      var vid = el.getAttribute('data-ol-variant-id');
      var pm = num(el.getAttribute('data-ol-max-product'));
      var vm = num(el.getAttribute('data-ol-max-variant'));
      var sc = el.getAttribute('data-ol-scope') || 'product';
      var msg = el.getAttribute('data-ol-msg');
      if (pid && pm > 0) { prodMax[pid] = pm; prodScope[pid] = sc; }
      if (vid && vm > 0) { varMax[vid] = vm; }
      if (msg) { if (pid) prodMsg[pid] = msg; if (vid) varMsg[vid] = msg; }
    });
    return { prodMax: prodMax, varMax: varMax, prodScope: prodScope, prodMsg: prodMsg, varMsg: varMsg };
  }

  /* ---- page-wide limit registry: cart lines + product cards + PDP buy block ----
     Lets the /cart/add interceptor look up a limit for ANY product being added
     (collection / cross-sell / ranking / quick-buy), not just items already in the cart. */
  function buildRegistry() {
    var prodLimit = {}, varLimit = {}, v2p = {};
    // cart lines already in cart: per-product + per-variant maxes + variant→product
    [].slice.call(document.querySelectorAll('[data-ol-product-id]:not([data-ol-card])')).forEach(function (el) {
      var pid = el.getAttribute('data-ol-product-id');
      var vid = el.getAttribute('data-ol-variant-id');
      var pm = num(el.getAttribute('data-ol-max-product'));
      var vm = num(el.getAttribute('data-ol-max-variant'));
      var sc = el.getAttribute('data-ol-scope') || 'product';
      var msg = el.getAttribute('data-ol-msg');
      if (pid && pm > 0 && !prodLimit[pid]) prodLimit[pid] = { max: pm, scope: sc, msg: msg || '' };
      if (vid && vm > 0) varLimit[vid] = vm;
      if (vid && pid) v2p[vid] = pid;
    });
    // product cards / PDP buy block: product-level limit + full variant list
    [].slice.call(document.querySelectorAll('[data-ol-card]')).forEach(function (el) {
      var pid = el.getAttribute('data-ol-product-id');
      var pm = num(el.getAttribute('data-ol-max-product'));
      var sc = el.getAttribute('data-ol-scope') || 'product';
      var msg = el.getAttribute('data-ol-msg');
      if (pid && pm > 0) {
        if (!prodLimit[pid]) prodLimit[pid] = { max: pm, scope: sc, msg: msg || '' };
        else if (msg && !prodLimit[pid].msg) prodLimit[pid].msg = msg;
      }
      (el.getAttribute('data-ol-variants') || '').split(',').forEach(function (vid) {
        vid = (vid || '').replace(/\s/g, '');
        if (vid && pid) v2p[vid] = pid;
      });
    });
    return { prodLimit: prodLimit, varLimit: varLimit, v2p: v2p };
  }

  /* ---- parse a /cart/add body into [{id, quantity}] (FormData / urlencoded / JSON {id} / JSON {items:[]}) ---- */
  function normalizeJson(j) {
    if (!j) return [];
    if (j.items && j.items.length) return [].slice.call(j.items).map(function (it) { return { id: String(it.id), quantity: num(it.quantity) || 1 }; });
    if (j.id != null) return [{ id: String(j.id), quantity: num(j.quantity) || 1 }];
    return [];
  }
  function parseAddItems(body) {
    try {
      if (!body) return [];
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var idF = body.get('id');
        return (idF != null) ? [{ id: String(idF), quantity: num(body.get('quantity')) || 1 }] : [];
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var idU = body.get('id');
        return (idU != null) ? [{ id: String(idU), quantity: num(body.get('quantity')) || 1 }] : [];
      }
      if (typeof body === 'string') {
        var s = body.replace(/^\s+/, '');
        if (s.charAt(0) === '{' || s.charAt(0) === '[') return normalizeJson(JSON.parse(s));
        var usp = new URLSearchParams(body);
        var idS = usp.get('id');
        return (idS != null) ? [{ id: String(idS), quantity: num(usp.get('quantity')) || 1 }] : [];
      }
      if (typeof body === 'object') return normalizeJson(body);
    } catch (e) {}
    return [];
  }

  /* ---- would this add exceed a limit? (cheap gate + precise check) ---- */
  function anyLimitRelevant(items) {
    var cfg = readConfig();
    if (cfg.totalMax > 0) return true;
    var reg = buildRegistry();
    for (var i = 0; i < items.length; i++) {
      var vid = String(items[i].id);
      if (reg.varLimit[vid] > 0) return true;
      var pid = reg.v2p[vid];
      if (pid && reg.prodLimit[pid]) return true;
    }
    return false;
  }
  function checkAddItems(items) {
    var cfg = readConfig();
    var reg = buildRegistry();
    var prodQty = {}, varQty = {};
    if (_cart && _cart.items) _cart.items.forEach(function (it) {
      var p = String(it.product_id), v = String(it.id);
      prodQty[p] = (prodQty[p] || 0) + it.quantity;
      varQty[v] = (varQty[v] || 0) + it.quantity;
      if (!reg.v2p[v]) reg.v2p[v] = p;
    });
    var addVar = {}, addProd = {}, i, vid, pid, qadd, lim;
    for (i = 0; i < items.length; i++) {
      vid = String(items[i].id); qadd = num(items[i].quantity) || 1; pid = reg.v2p[vid] || null;
      if (reg.varLimit[vid] > 0 && (varQty[vid] || 0) + (addVar[vid] || 0) + qadd > reg.varLimit[vid]) {
        return { block: true, msg: withSuffix(olMsg(cfg.prodTpl, reg.varLimit[vid]), cfg) };
      }
      if (pid && reg.prodLimit[pid]) {
        lim = reg.prodLimit[pid];
        if (lim.scope === 'variant') {
          if ((varQty[vid] || 0) + (addVar[vid] || 0) + qadd > lim.max) return { block: true, msg: withSuffix(olMsg(lim.msg || cfg.prodTpl, lim.max), cfg) };
        } else {
          if ((prodQty[pid] || 0) + (addProd[pid] || 0) + qadd > lim.max) return { block: true, msg: withSuffix(olMsg(lim.msg || cfg.prodTpl, lim.max), cfg) };
        }
      }
      addVar[vid] = (addVar[vid] || 0) + qadd;
      if (pid) addProd[pid] = (addProd[pid] || 0) + qadd;
    }
    if (cfg.totalMax > 0 && _cart) {
      var totalAdd = 0;
      for (i = 0; i < items.length; i++) totalAdd += num(items[i].quantity) || 1;
      if ((_cart.item_count || 0) + totalAdd > cfg.totalMax) return { block: true, msg: cfg.tpl.replace('{N}', cfg.totalMax) };
    }
    return { block: false };
  }

  /* ---- compute violation from cart.js JSON ---- */
  function compute(cart, cfg) {
    if (!cart) return { over: false, msg: '' };
    var prodQty = {}, varQty = {}, prodVars = {};
    (cart.items || []).forEach(function (it) {
      var p = String(it.product_id), v = String(it.id);
      prodQty[p] = (prodQty[p] || 0) + it.quantity;
      varQty[v] = (varQty[v] || 0) + it.quantity;
      (prodVars[p] = prodVars[p] || {})[v] = true;
    });
    var g = groupMaps(), over = false, msg = '';
    var k, vv;
    for (k in g.varMax) { if (varQty[k] > g.varMax[k]) { over = true; msg = olMsg(g.varMsg[k] || cfg.prodTpl, g.varMax[k]); } }
    for (k in g.prodMax) {
      if (g.prodScope[k] === 'variant') {
        for (vv in (prodVars[k] || {})) { if (varQty[vv] > g.prodMax[k]) { over = true; msg = olMsg(g.prodMsg[k] || cfg.prodTpl, g.prodMax[k]); } }
      } else {
        if ((prodQty[k] || 0) > g.prodMax[k]) { over = true; msg = olMsg(g.prodMsg[k] || cfg.prodTpl, g.prodMax[k]); }
      }
    }
    if (!over && cfg.totalMax > 0 && cart.item_count > cfg.totalMax) {
      over = true; msg = cfg.tpl.replace('{N}', cfg.totalMax);
    }
    return { over: over, msg: msg };
  }

  /* ---- apply UI state (alert / checkout disable / express hide) ---- */
  function applyState(v, cfg) {
    window.__seasarOLOver = !!v.over;
    [].slice.call(document.querySelectorAll('[data-ol-alert]')).forEach(function (a) {
      if (v.over) { a.textContent = v.msg; a.hidden = false; }
      else { a.textContent = ''; a.hidden = true; }
    });
    [].slice.call(document.querySelectorAll('button[name="checkout"],input[name="checkout"]')).forEach(function (b) {
      b.disabled = !!v.over;
      if (v.over) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      b.classList.toggle('is-ol-blocked', !!v.over);
    });
    if (cfg.blockExpress) {
      [].slice.call(document.querySelectorAll('.cart-drawer__express,[data-strip-shop-pay],.shopify-payment-button,shopify-accelerated-checkout')).forEach(function (e) {
        e.style.display = v.over ? 'none' : '';
      });
    }
  }

  /* transient warning (used when blocking a + click before it exceeds) */
  function showOlWarn(msg) {
    var alerts = [].slice.call(document.querySelectorAll('[data-ol-alert]'));
    alerts.forEach(function (a) { a.textContent = msg; a.hidden = false; });
    var vis = alerts.filter(function (a) { return a.offsetParent !== null; })[0];
    if (vis) { try { vis.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {} }
    if (window.__olWarnT) clearTimeout(window.__olWarnT);
    window.__olWarnT = setTimeout(function () { recheck(true); }, 4000);
  }

  /* floating toast — used when blocking an add outside the cart (collection / PDP / cross-sell) where no cart alert is on screen */
  function showOlToast(msg) {
    showOlWarn(msg); // also fill any visible cart alert
    var t = document.getElementById('seasar-ol-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'seasar-ol-toast';
      t.setAttribute('role', 'alert');
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(8px);z-index:2147483000;max-width:min(92vw,420px);background:#2a1a10;color:#fff;padding:13px 18px;border-radius:12px;font-size:13.5px;line-height:1.6;box-shadow:0 8px 30px rgba(0,0,0,.28);opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;text-align:center;';
      (document.body || document.documentElement).appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
    if (window.__olToastT) clearTimeout(window.__olToastT);
    window.__olToastT = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(8px)'; }, 4200);
  }

  /* inline warning shown right under the quantity stepper that was clicked (cart drawer / cart page) */
  function showInlineWarn(plusEl, msg) {
    if (!plusEl) { showOlToast(msg); return; }
    var host = plusEl.closest('line-item-quantity') || plusEl.closest('.quantity-selector') || plusEl.parentElement;
    if (!host || !host.parentNode) { showOlToast(msg); return; }
    var sib = host.nextElementSibling;
    if (!(sib && sib.classList && sib.classList.contains('ol-inline-warn'))) {
      sib = document.createElement('div');
      sib.className = 'ol-inline-warn';
      sib.setAttribute('role', 'alert');
      sib.style.cssText = 'flex-basis:100%;width:100%;margin:6px 0 0;color:#b00020;font-size:11.5px;line-height:1.5;font-weight:600;';
      host.parentNode.insertBefore(sib, host.nextSibling);
    }
    sib.textContent = msg;
    sib.style.display = '';
    try { sib.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    if (sib._olT) clearTimeout(sib._olT);
    sib._olT = setTimeout(function () { if (sib && sib.style) sib.style.display = 'none'; }, 4500);
  }

  /* intercept the cart "+" (increase) before theme.js processes it; block + warn if it would exceed a limit */
  function onCartIncreaseClick(ev) {
    var t = ev.target;
    var a = (t && t.closest) ? t.closest('a.quantity-selector__button') : null;
    if (!a) return;
    var cfg = readConfig();
    if (!enabled(cfg)) return;
    var href = a.getAttribute('href') || '';
    var mId = href.match(/[?&]id=([^&]+)/), mQ = href.match(/[?&]quantity=(\d+)/);
    if (!mId || !mQ) return;
    var key = decodeURIComponent(mId[1]), target = parseInt(mQ[1], 10);
    // identify the cart line by key (works even when the "+" is outside the line element, e.g. cart page desktop)
    var li = null;
    if (_cart && _cart.items) _cart.items.forEach(function (it) { if (it.key === key) li = { product_id: it.product_id, id: it.id, quantity: it.quantity }; });
    if (!li) { // fallback: read from the rendered line element when the cart cache is not primed yet
      var lel = null;
      [].slice.call(document.querySelectorAll('[data-ol-key]')).forEach(function (el) { if (el.getAttribute('data-ol-key') === key) lel = el; });
      if (lel) li = { product_id: lel.getAttribute('data-ol-product-id'), id: lel.getAttribute('data-ol-variant-id'), quantity: num(lel.getAttribute('data-ol-qty')) };
    }
    if (!li || target <= li.quantity) return; // decrease/no-change → allow
    var delta = target - li.quantity;
    var pid = String(li.product_id), vid = String(li.id);
    var g = groupMaps(); // per-product/variant maxes from all line-item data attrs on the page
    var prodSum = 0, varSum = 0;
    if (_cart && _cart.items) {
      _cart.items.forEach(function (it) {
        if (String(it.product_id) === pid) prodSum += it.quantity;
        if (String(it.id) === vid) varSum += it.quantity;
      });
    } else {
      [].slice.call(document.querySelectorAll('[data-ol-product-id]:not([data-ol-card])')).forEach(function (el) {
        var q = num(el.getAttribute('data-ol-qty'));
        if (el.getAttribute('data-ol-product-id') === pid) prodSum += q;
        if (el.getAttribute('data-ol-variant-id') === vid) varSum += q;
      });
    }
    var exceed = false, msg = '';
    if (g.varMax[vid] > 0 && (varSum + delta) > g.varMax[vid]) { exceed = true; msg = withSuffix(olMsg(g.varMsg[vid] || cfg.prodTpl, g.varMax[vid]), cfg); }
    else if (g.prodMax[pid] > 0 && g.prodScope[pid] === 'variant' && (varSum + delta) > g.prodMax[pid]) { exceed = true; msg = withSuffix(olMsg(g.prodMsg[pid] || cfg.prodTpl, g.prodMax[pid]), cfg); }
    else if (g.prodMax[pid] > 0 && g.prodScope[pid] !== 'variant' && (prodSum + delta) > g.prodMax[pid]) { exceed = true; msg = withSuffix(olMsg(g.prodMsg[pid] || cfg.prodTpl, g.prodMax[pid]), cfg); }
    else if (cfg.totalMax > 0 && _cart && (_cart.item_count + delta) > cfg.totalMax) { exceed = true; msg = (cfg.tpl || '1回のご注文は合計{N}点までです。数量をご調整ください。').replace('{N}', cfg.totalMax); }
    if (exceed) { ev.preventDefault(); ev.stopImmediatePropagation(); showInlineWarn(a, msg); }
  }

  /* belt-and-suspenders: block any checkout form submit while over */
  document.addEventListener('submit', function (ev) {
    if (!window.__seasarOLOver) return;
    var f = ev.target;
    if (f && f.querySelector && f.querySelector('[name="checkout"]')) {
      ev.preventDefault(); ev.stopPropagation();
      var a = document.querySelector('[data-ol-alert]');
      if (a) { a.hidden = false; try { a.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
    }
  }, true);

  /* ---- recheck (debounced) ---- */
  var _raf = null;
  function recheck(useCached) {
    var cfg = readConfig();
    if (!enabled(cfg)) { window.__seasarOLOver = false; return; }
    var p = (useCached && _cart) ? Promise.resolve(_cart) : fetchCart();
    p.then(function (cart) { applyState(compute(cart, cfg), cfg); });
  }
  function recheckDebounced(useCached) {
    if (_raf) cancelAnimationFrame(_raf);
    _raf = requestAnimationFrame(function () { _raf = null; recheck(useCached); });
  }

  /* ---- PDP: cap quantity + block add over limit ---- */
  function flash(el) {
    if (!el) return;
    el.classList.remove('is-ol-flash'); void el.offsetWidth; el.classList.add('is-ol-flash');
  }
  function bindPdp() {
    var buy = document.querySelector('[data-stp-buy]');
    if (!buy) return;
    var cfg = readConfig();
    var pmax = num(buy.getAttribute('data-stp-limit-max'));
    var scope = buy.getAttribute('data-stp-limit-scope') || 'product';
    var pid = buy.getAttribute('data-stp-product-id');
    var pmsg = buy.getAttribute('data-ol-msg');
    if (pmax <= 0 && cfg.totalMax <= 0) return;
    var qIn = buy.querySelector('[data-stp-qtyinput]');
    var qPlus = buy.querySelector('[data-stp-qtyplus]');
    var cta = buy.querySelector('[data-stp-cta]');
    var note = buy.querySelector('[data-stp-limit-note]');
    var idInput = buy.querySelector('[data-stp-id]');

    if (qIn && pmax > 0) {
      qIn.setAttribute('max', String(pmax));
      qIn.addEventListener('input', function () {
        var n = num(qIn.value);
        if (n > pmax) { qIn.value = String(pmax); flash(note); }
        if (qPlus) qPlus.disabled = num(qIn.value) >= pmax;
      });
      if (qPlus && num(qIn.value) >= pmax) qPlus.disabled = true;
    }
    // prime cart cache for synchronous decision at click time
    fetchCart();
    if (cta) {
      cta.addEventListener('click', function (ev) {
        if (cta.disabled) return;
        if (!_cart) return; // fail-open before cache primed; cart safety-net still blocks checkout
        var want = qIn ? Math.max(1, num(qIn.value)) : 1;
        var curVid = idInput ? idInput.value : null;
        var inProd = 0, inVar = 0;
        (_cart.items || []).forEach(function (it) {
          if (pid && String(it.product_id) === String(pid)) inProd += it.quantity;
          if (curVid && String(it.id) === String(curVid)) inVar += it.quantity;
        });
        var exceed = false, m = '';
        if (pmax > 0) {
          var have = scope === 'variant' ? inVar : inProd;
          if (have + want > pmax) { exceed = true; m = withSuffix(olMsg(pmsg || cfg.prodTpl, pmax), cfg); }
        }
        if (!exceed && cfg.totalMax > 0 && (_cart.item_count + want) > cfg.totalMax) {
          exceed = true; m = cfg.tpl.replace('{N}', cfg.totalMax);
        }
        if (exceed) {
          ev.preventDefault(); ev.stopImmediatePropagation();
          if (note) { note.textContent = m; note.hidden = false; flash(note); }
        }
      }, true);
    }
  }

  /* ---- wire ---- */
  function wire() {
    document.addEventListener('cart:change', function (e) {
      if (e && e.detail && e.detail.cart) setCart(e.detail.cart);
      recheckDebounced(true);
    });
    document.addEventListener('cart-drawer:refreshed', function () { recheckDebounced(false); });
    document.addEventListener('cart:refresh', function () { recheckDebounced(false); });
    document.addEventListener('cart:open', function () { recheckDebounced(false); });
    document.addEventListener('click', onCartIncreaseClick, true);
    window.addEventListener('pageshow', function () { recheckDebounced(false); });
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var mo = new MutationObserver(function () { recheckDebounced(true); });
      mo.observe(drawer, { childList: true, subtree: true });
    }
    bindPdp();
    recheck(false);
  }
  /* ---- universal /cart/add interceptor: catches every add path (PDP, cards, cross-sell, ranking, quick-buy modal, arcade) ----
     They ALL POST to /cart/add[.js]; we wrap fetch, look the item's limit up in the page-wide registry,
     and cancel the request (returning a 422 the theme treats as an add error) + show a toast if it would exceed. */
  function isAddUrl(u) { return /\/cart\/add(\.js)?($|\?)/.test(u || ''); }
  function blockedResponse(msg) {
    var payload = JSON.stringify({ status: 422, message: '数量制限', description: msg });
    if (typeof Response === 'function') {
      try { return new Response(payload, { status: 422, statusText: 'Unprocessable Entity', headers: { 'Content-Type': 'application/json' } }); } catch (e) {}
    }
    return { ok: false, status: 422, json: function () { return Promise.resolve(JSON.parse(payload)); }, text: function () { return Promise.resolve(payload); } };
  }
  (function patchFetch() {
    if (!window.fetch || window.__seasarOLFetch) return;
    window.__seasarOLFetch = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var self = this, args = arguments;
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && isAddUrl(url)) {
          var body = (init && init.body !== undefined && init.body !== null) ? init.body : (input && input.body);
          var items = parseAddItems(body);
          if (items.length && anyLimitRelevant(items)) {
            return fetchCart().then(function () {
              var res = checkAddItems(items);
              if (res.block) { showOlToast(res.msg); return blockedResponse(res.msg); }
              return orig.apply(self, args);
            });
          }
        }
      } catch (e) {}
      return orig.apply(self, args);
    };
  })();

  window.SeasarOrderLimit = { recheck: recheck };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
})();
